import type { ReactNode } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Login } from './pages/Login';
import { Dashboard } from './pages/Dashboard';
import { Tenants } from './pages/Tenants';
import { FeatureFlags } from './pages/FeatureFlags';
import { Quotas } from './pages/Quotas';
import { AuditLogs } from './pages/AuditLogs';
import { Lite } from './pages/Lite';
import { LiteAds } from './pages/LiteAds';
import { SystemSettings } from './pages/SystemSettings';
import { ToolStationVisible } from './pages/ToolStationVisible';

/**
 * 檢查是否已登入（從 localStorage 取得 Token）
 */
function isAuthenticated(): boolean {
  const token = localStorage.getItem('super_admin_token');
  return !!token;
}

/**
 * 受保護的路由元件
 */
function ProtectedRoute({ children }: { children: ReactNode }) {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
}

/**
 * 公開路由元件（已登入時重定向到 dashboard）
 */
function PublicRoute({ children }: { children: ReactNode }) {
  if (isAuthenticated()) {
    return <Navigate to="/dashboard" replace />;
  }
  return <>{children}</>;
}

export function Router() {
  return (
    <Routes>
      <Route
        path="/login"
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/tenants"
        element={
          <ProtectedRoute>
            <Tenants />
          </ProtectedRoute>
        }
      />
      <Route
        path="/feature-flags"
        element={
          <ProtectedRoute>
            <FeatureFlags />
          </ProtectedRoute>
        }
      />
      <Route
        path="/quotas"
        element={
          <ProtectedRoute>
            <Quotas />
          </ProtectedRoute>
        }
      />
      <Route
        path="/audit-logs"
        element={
          <ProtectedRoute>
            <AuditLogs />
          </ProtectedRoute>
        }
      />
      <Route
        path="/lite"
        element={
          <ProtectedRoute>
            <Lite />
          </ProtectedRoute>
        }
      />
      <Route
        path="/lite-ads"
        element={
          <ProtectedRoute>
            <LiteAds />
          </ProtectedRoute>
        }
      />
      <Route
        path="/system-settings"
        element={
          <ProtectedRoute>
            <SystemSettings />
          </ProtectedRoute>
        }
      />
      <Route
        path="/tool-station-visible"
        element={
          <ProtectedRoute>
            <ToolStationVisible />
          </ProtectedRoute>
        }
      />
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
